import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'htmlFormat',
  standalone: false
})
export class HtmlFormatPipe implements PipeTransform {
  public constructor(private sanitizer: DomSanitizer) {}

  public transform(value: string): SafeHtml | string {
    if(!value || value.length === 0) {
      return '';
    }

    //todo - update for notifications - this functionality including customized link href replacement
    const formatted = value.replace(/\n/g, '<br>');
    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }
}